<template>
    <div style="width:100%; height: 100%; background-image: url('/img/bgd-banner.jpg')">
        <v-container>
            <v-card>
                <v-card-title dark class="white--text" style="background-color:#00aeef">
                    <!-- <v-btn icon @click.native="goBack()" class="mr-5">
                        <v-icon color="white">mdi-arrow-left</v-icon>
                    </v-btn> -->
                    Register
                </v-card-title>
                <form>
                    <v-layout row wrap pt-4 px-10>
                        <v-flex xs12>
                            <v-text-field
                                v-model="email"
                                label="Email"
                                :counter="50"
                                :error-messages="errors.collect('Email')"
                                v-validate="'required|email|max:50'"
                                data-vv-name="Email"
                                data-cy="txtEmail"
                            ></v-text-field>
                        </v-flex>
                        <br />
                        <v-flex xs12>
                            <v-text-field
                                v-model="firstName"
                                label="First Name"
                                :counter="50"
                                :error-messages="errors.collect('First Name')"
                                v-validate="'required|alpha_spaces|max:50'"
                                data-vv-name="First Name"
                                data-cy="txtFirstName"
                            ></v-text-field>
                        </v-flex>
                        <br />
                        <v-flex xs12>
                            <v-text-field
                                v-model="lastName"
                                label="Last Name"
                                :counter="50"
                                :error-messages="errors.collect('Last Name')"
                                v-validate="'required|alpha_spaces|max:50'"
                                data-vv-name="Last Name"
                                data-cy="txtLastName"
                            ></v-text-field>
                        </v-flex>
                        <br />
                        <br />
                        <v-flex xs12>
                            <v-text-field
                                v-model="companyName"
                                label="Company"
                                :counter="50"
                                :error-messages="errors.collect('Company')"
                                v-validate="'required|max:50'"
                                data-vv-name="Company"
                                data-cy="txtcompany"
                            ></v-text-field>
                        </v-flex>
                        <br />
                        <v-flex xs12>
                            <v-text-field
                                v-model="password"
                                label="Password"
                                type="password"
                                :counter="50"
                                :error-messages="errors.collect('Password')"
                                v-validate="'required|max:50|min:8'"
                                data-vv-name="Password"
                                data-cy="txtPassword"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                v-model="passwordReenter"
                                label="Re-Enter Password"
                                type="password"
                                :counter="50"
                                :error-messages="errors.collect('PasswordReEnter')"
                                v-validate="{ required: true, is: password }"
                                data-vv-name="PasswordReEnter"
                                data-vv-as="Re-Enter Password"
                                data-cy="txtPasswordReEnter"
                            ></v-text-field>
                        </v-flex>
                        <br />
                        <v-row>
                            <v-col  class="text-left">
                                <v-btn
                                    color="hubblue"
                                    class="white--text"
                                    @click="save"
                                    :loading="loading"
                                    :disabled="loading"
                                    data-cy="btnRegister"
                                    >Register
                                </v-btn>
                             </v-col>
                            <v-col class="text-right">
                                <v-btn 
                                    text
                                    color="hubblue" 
                                    class="white--text" 
                                    @click='resetPwDialog = true'
                                    >reset password
                                </v-btn>
                            </v-col>
                        </v-row>
                            <v-dialog v-model="resetPwDialog" persistent max-width="400px">
                                <v-form @submit.prevent="onResetPwSubmit">
                                    <v-card>
                                        <v-card-title>
                                            <span>Reset Password</span>
                                            <v-spacer></v-spacer>
                                            <v-btn icon @click="closeDialog" :disabled="resetPwInProgress">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                            <v-text-field 
                                                v-model="resetPwEmail" 
                                                v-validate="'required|email'"
                                                :error-messages="errors.collect('Reset Password Email')"
                                                data-vv-name="Reset Password Email"
                                                class="requires--text"
                                                data-cy="Reset Password Email" 
                                                label="Email" 
                                            ></v-text-field>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        <v-card-actions>
                                            <v-btn
                                                type="submit"
                                                color="primary"
                                                :loading="resetPwInProgress"
                                                :disabled="resetPwInProgress"
                                                >Submit</v-btn
                                            >
                                        </v-card-actions>
                                    </v-card>
                                </v-form>
                            </v-dialog>
                    </v-layout>
                </form>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    $_veeValidate: {
        validator: 'new' // give me a new validator each time.
    },
    data() {
        return {
            loading: false,
            email: null,
            firstName: null,
            lastName: null,
            companyName: null,
            password: null,
            passwordReenter: null,
            resetPwDialog:false,
            resetPwInProgress:false,
            resetPwEmail:''
        }
    },

    methods: {
        createUser() {
            this.loading = true
            const app = this
            let snackbarParams

            let params = {
                email: app.email,
                firstName: app.firstName,
                lastName: app.lastName,
                companyName: app.companyName,
                password: app.password
            }

            axios
                .post(app.$store.state.userUrl, params)
                .then(response => {
                    app.loading = false
                    snackbarParams = {
                        message: response.data,
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    this.$router.push({ name: 'Login' })
                })
                .catch(error => {
                    console.log(error)
                    app.loading = false
                    snackbarParams = {
                        message: error.response && error.response.data ? error.response.data+' Please use another email or reset password' : error,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                })
        },
        save() {
            this.$validator
                .validateAll()
                .then(validated => {
                    if (validated) {
                        this.createUser()
                    }
                })
                .catch(() => {
                    return false
                })
        },
        onResetPwSubmit() {
            this.$validator
                .validate('Reset Password Email', this.resetPwEmail)
                .then(validated=>{
                    if(validated){
                       this.resetPwInProgress = true
                       axios.post(this.$store.state.resetPwRequestUrl, { email: this.resetPwEmail })
                            .then(response => {
                                this.$store.commit('showSnackbar', {
                                    message: response.data,
                                    context: 'success'
                                })
                                this.resetPwEmail = ''
                                this.resetPwDialog = false
                            })
                            .catch(error => {
                                this.$store.commit('showSnackbar', {
                                        message: error.response ? error.response.data : 'Network error',
                                        context: 'error'
                                    })
                            })
                            .finally(() => {
                                 this.resetPwInProgress = false
                            })
                    }
                })
        },
        goBack() {
            this.$router.go(-1)
            this.email = null
            this.firstName = null
            this.lastName = null
            this.companyName = null
            this.password = null
            this.passwordReenter = null
        },
        closeDialog(){
            this.resetPwDialog = false
            this.errors.clear()
            this.resetPwEmail = ''
        }
    },
    watch:{
        resetPwEmail(){
            this.errors.clear()
        }
    }
}
</script>
